import { AfterViewInit, Component, Input, OnInit, ViewChild } from '@angular/core';

@Component({
  selector: 'app-apply-payment',
  templateUrl: './apply-payment.component.html',
  styleUrls: ['./apply-payment.component.scss']
})
export class ApplyPaymentComponent implements OnInit {

  @Input() groupBillNo;
  @Input() amount;
  @Input() poNumber;
  @Input() totalMember;

  constructor() { }

  ngOnInit(): void {
    
  }
  
}
